import { render, staticRenderFns } from "./platticketpick-add-or-update.vue?vue&type=template&id=25c4e929&"
import script from "./platticketpick-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platticketpick-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports